import React, { useState } from "react";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../css/experience.css";
import degreeImage from "../assets/images/46a4d5f0d92f887ddbae1b7b46ea0302665c7063.png";
import schoolImage from "../assets/images/1ed1f8b7bf206e48b3f2bbd9d09c51aee2ba7168.png";
import ceoCertificate from "../assets/images/ceo_certificate.png";
import cioCertificate from "../assets/images/cio_certificate.png";
import employeeCertificate from "../assets/images/employee_of_month.png";

const roles = [
  {
    company: "Safaricom ET PLC",
    title: "Fullstack Developer",
    period: "April 2026 – Present",
    location: "Addis Ababa, Ethiopia · On-site",
    paragraphs: [
      "Building fintech-grade software for one of Africa's leading telcos. Developed and launched a mini-application inside the M-PESA Business (Merchant) Super App, engineered internal systems used across multiple business units, and implemented Kubernetes-based CI/CD pipelines enabling zero-downtime deployments.",
    ],
    skills: "NextJs, Express, Flutter and +4 skills",
  },
  {
    company: "Amhara Bank SC",
    title: "Software Developer & Fullstack Developer",
    period: "Jun 2022 – Apr 2026",
    location: "Addis Ababa, Ethiopia · On-site",
    paragraphs: [
      "Built core digital banking products end-to-end — ABA Mobile Banking, Merchant, Share, and Lottery apps — plus the enterprise systems behind them (HRMS, Payroll, Shareholder Management). Delivered PCI-DSS compliant payments, QR transactions, and secure Flutter-based mobile experiences across Play Store and App Store.",
    ],
    skills: "Flutter, Clean Architecture, Next.js, FinTech and +8 skills",
  },
  {
    company: "Zentyad Trading PLC",
    title: "Fullstack Developer (Part-time)",
    period: "June 2024 – April 2026",
    location: "Addis Ababa, Ethiopia · Remote",
    paragraphs: [
      "Delivered a multi-company e-commerce platform and deployed ERP suites (HRMS, payroll, admin) for multiple client companies. Also built a MERN stack survey platform with secure access, offline-first PWA submission, and real-time analytics.",
    ],
    skills: "MERN Stack, Next.js, PWA and +5 skills",
  },
];

const awards = [
  {
    title: "CEO Recognition Award",
    issuer: "Amhara Bank SC",
    period: "July, 2023",
    image: ceoCertificate,
  },
  {
    title: "CIO Excellence Award",
    issuer: "Amhara Bank SC",
    period: "September, 2024",
    image: cioCertificate,
  },
  {
    title: "Employee of the Month",
    issuer: "Safaricom ET PLC",
    period: "August, 2026",
    image: employeeCertificate,
  },
];
const RoleCard = ({ role, isExpanded, onToggle }) => {
  return (
    <article className="role-card">
      <div className="role-dot" />
      <div className="role-body">
        <div className="role-topline">
          <span className="role-company">{role.company}</span>
          <span className="role-period">{role.period}</span>
        </div>
        <h3>{role.title}</h3>
        {role.location && <p className="role-location">{role.location}</p>}

        <div
          className={`role-description ${
            isExpanded ? "expanded" : "collapsed"
          }`}
        >
          {role.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        <button
          type="button"
          className="see-more-btn"
          onClick={onToggle}
          aria-expanded={isExpanded}
        >
          {isExpanded ? "see less" : "...see more"}
        </button>

        {role.skills && <span className="role-skills">{role.skills}</span>}
      </div>
    </article>
  );
};

export const Experience = () => {
  const [selectedAward, setSelectedAward] = useState(null);
  const [expandedRole, setExpandedRole] = useState(null);

  const handleToggle = (roleKey) => {
    setExpandedRole((prev) => (prev === roleKey ? null : roleKey));
  };

  return (
    <>
      <section className="experience-section" id="experience">
        <div className="experience-header">
          <span className="section-tag">Experience & Education</span>
          <h2>Professional Journey</h2>
        </div>

        <div className="experience-grid">
          <div className="timeline-panel">
            {roles.map((role) => {
              const roleKey = `${role.company}-${role.title}`;
              return (
                <RoleCard
                  key={roleKey}
                  role={role}
                  isExpanded={expandedRole === roleKey}
                  onToggle={() => handleToggle(roleKey)}
                />
              );
            })}
          </div>

          <aside className="education-panel">
            <div className="panel-group">
              <span className="card-title">Education</span>

              <div className="education-entry">
                <div
                  className="education-image"
                  style={{ backgroundImage: `url(${degreeImage})` }}
                />
                <div className="education-text">
                  <strong>BSc in Information Systems</strong>
                  <span>Mizan Tepi University</span>
                  <span>CGPA: 3.91 / 4.0</span>
                </div>
              </div>

              <div className="education-entry">
                <div
                  className="education-image"
                  style={{ backgroundImage: `url(${schoolImage})` }}
                />
                <div className="education-text">
                  <strong>Preparatory & High School</strong>
                  <span>Goro Secondary & Preparatory School</span>
                  <span>Adama, Oromia Region</span>
                </div>
              </div>
            </div>

            <div className="panel-group honor-group">
              <span className="card-title">Honors & Rewards</span>

              <div className="award-grid">
                {awards.map((award) => (
                  <button
                    type="button"
                    className="award-entry"
                    key={award.title}
                    onClick={() => setSelectedAward(award)}
                  >
                    <div
                      className="award-image"
                      style={{
                        backgroundImage: award.image
                          ? `url(${award.image})`
                          : "none",
                        backgroundColor: award.image
                          ? "transparent"
                          : "rgba(73, 177, 82, 0.12)",
                      }}
                    >
                      {!award.image && <span>Certificate</span>}
                    </div>

                    <div className="award-text">
                      <strong>{award.title}</strong>
                      <span>{award.issuer}</span>
                      <span>{award.period}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>

      <Dialog
        open={Boolean(selectedAward)}
        onClose={() => setSelectedAward(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          className: "award-dialog",
        }}
      >
        {selectedAward && (
          <>
            <div className="award-dialog-header">
              <div>
                <span className="award-dialog-label">Certificate</span>
                <h3>{selectedAward.title}</h3>
              </div>
              <IconButton
                aria-label="close certificate"
                onClick={() => setSelectedAward(null)}
                className="award-dialog-close"
              >
                <CloseIcon />
              </IconButton>
            </div>

            <img
              src={selectedAward.image}
              alt={selectedAward.title}
              className="award-full-image"
            />
          </>
        )}
      </Dialog>
    </>
  );
};
